import React from 'react'
import { useState, useEffect } from "react";

const BottomTopBtn = () => {
    const [showButton, setShowButton] = useState(false);

    // Handle scroll event to show or hide the button
    const handleScroll = () => {
        if (window.pageYOffset > 100) {
            setShowButton(true);
        } else {
            setShowButton(false);
        }
    };

    // Scroll to top functionality
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Add event listener on mount and cleanup on unmount
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    return (
        <>
            <button className="bottom-top-button" onClick={scrollToTop}>&#8593;</button>
        </>
    )
}

export default BottomTopBtn